import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/vrt_protests`, {params: {...filters}})
  },

  show(id) {
    return Http.get(`/vrt_protests/${id}`);
  },
  
  create(vrt_protest){
    return Http.post(`/vrt_protests`, {vrt_protest: {...vrt_protest}})
  },

  updateAsSolved(vrt_protest) {
    return Http.put(`/vrt_protests/solve_protest/${vrt_protest.id}`, {vrt_protest: {...vrt_protest}});
  },

}
